var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3Share(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.89 52.75a7 7 0 11-13.92-1l-16.25-8.9a7 7 0 11.61-10.26l15.83-9.19a7 7 0 112.15 3.38l-16.15 9.37a6.93 6.93 0 01-.16 3.37l15.71 8.57a7 7 0 0112.21 4.66h-.03z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Share.8c4dec9f.svg";
export { SvgJ3Share as ReactComponent };